import React from 'react';
import FPDrawer from 'UI/components/templates/FPDrawer/FPDrawer';

import { DEBRIEF_TITLE_BY_PARTICIPANT } from './SendoutInterviewDebriefDrawer.constants';

export const SendoutInterviewDebriefDetailsDrawer = ({ onClose = () => {}, participant }) => (
  <FPDrawer
    FPDrawerProps={{ open: true }}
    CardHeaderProps={{ title: DEBRIEF_TITLE_BY_PARTICIPANT[participant] }}
    onClose={onClose}
  >
    <div />
  </FPDrawer>
);
